<template>
    <div class="review-slider">
        <div class="flex flex-row justify-end gap-4 mb-16">
            <div class="button-prev text-blue cursor-pointer">
                <Icon type="TailLeft" viewBox="0 0 30 21" width="25" height="26" fill="none" class="stroke-current" />
            </div>
            <div class="button-next text-blue cursor-pointer">
                <Icon type="TailRight" viewBox="0 0 30 21" width="25" height="26" fill="none" class="stroke-current" />
            </div>
        </div>

        <div class="swiper-wrapper">
            <div class="swiper-slide" v-for="(review, index) in data" :key="index">
                <Review :data="review" :slideChanging="slideChanging" />
            </div>
        </div>

        <div class="swiper-scrollbar"></div>
    </div>
</template>

<script>
import Swiper, { Navigation } from 'swiper';
Swiper.use([Navigation]);

export default {
    data() {
        return {
            slideChanging: false
        };
    },
    mounted() {
        this.init();
    },

    props: ['data'],

    methods: {
        init() {
            let reviewsComponent = this;
            new Swiper('.review-slider', {
                slidesPerView: 1,
                spaceBetween: 80,
                loop: false,
                navigation: {
                    nextEl: '.button-next',
                    prevEl: '.button-prev'
                },
                breakpoints: {
                    480: {
                        slidesPerView: 1
                    },
                    640: {
                        slidesPerView: 3
                    },
                    1024: {
                        slidesPerView: 3
                    },
                    1200: {
                        slidesPerView: 3
                    }
                },
                on: {
                    slideChangeTransitionStart: function () {
                        reviewsComponent.slideChanging = true;
                    },
                    slideChangeTransitionEnd: function () {
                        reviewsComponent.slideChanging = false;
                    }
                }
            });
        }
    }
};
</script>
